export default "__VITE_ASSET__CiQZ2QAm__"